import { UserFacingError } from "src/lib/user-facing-error";

// Hasura permission filters exclude unauthorized rows instead of erroring:
// an update/delete *_by_pk mutation resolves with null and a bulk mutation
// reports fewer affected rows than requested. Without these guards the UI
// reports success for a write that never landed.

export class WriteNotAppliedError extends UserFacingError {
  override readonly name = "WriteNotAppliedError";
}

/**
 * A permission-filtered NESTED insert does error, but with engine internals:
 * 'cannot proceed to insert object relation "x" since insert to table "y"
 * affects zero rows'. Translate that shape into the standard permission
 * message; anything else rethrows untouched.
 */
export function rethrowNestedInsertDenial(
  error: unknown,
  action: string,
): never {
  if (
    error instanceof Error &&
    /cannot proceed to insert object relation .* affects zero rows/.test(
      error.message,
    )
  ) {
    throw new WriteNotAppliedError(`You do not have permission to ${action}`);
  }
  throw error;
}

export function ensureRowAffected<T>(
  row: T | null | undefined,
  action: string,
): T {
  if (row === null || row === undefined) {
    throw new WriteNotAppliedError(`You do not have permission to ${action}`);
  }
  return row;
}

export function ensureRowsAffected(
  result: { affected_rows: number } | null | undefined,
  expected: number,
  action: string,
): void {
  if ((result?.affected_rows ?? 0) < expected) {
    throw new WriteNotAppliedError(`You do not have permission to ${action}`);
  }
}
